/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { Box, Flex, Heading } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { ProgramSupportSt } from '@ieo/Common/CompLangConfig';
import SingleImage from '@ieo/Components/SingleImage';

/* Services */
/* Styles */

/**
 * @param {Object} card
 * @param {String} region
 * @param {String} lang
 * @param {String} flexBasis
 * @returns
 */
const RemarketProgramSupportCard = ({
  card,
  lang,
  region,
  flexBasis,
  pageData,
  color,
}) => {
  const readLessTxtCount = 35;
  const [show, setShow] = useState(false);
  const [readMoreTxt, setReadMoreTxt] = useState(readLessTxtCount);
  const [txtHide, setTxtHide] = useState(true);
  const descText = render(card?.description);

  const viewText = () => {
    setReadMoreTxt(-1);
    setTxtHide(false);
  };
  const lessText = () => {
    setReadMoreTxt(readLessTxtCount);
    setTxtHide(true);
  };

  return (
    <Box
      w={{ base: '100%', sm: '318px', md: '47%', lg: '30%' }}
      flexBasis={{ base: 'auto', md: 'auto', lg: flexBasis }}
    >
      <Box
        h="auto"
        maxW={{ base: '100%', md: '100%', lg: '318px' }}
        // minH={{base:"270px"}}
        bg="#F1EBDF"
        display="flex"
        justifyContent="space-between"
        flexDir="column"
      >
        <Box
          maxW={lang === 'ar' ? '100%' : '100px'}
          alignSelf={'auto'}
          //height={{ base: '40%', sm: '35%' }}
          pt={{ base: '18px', sm: '15px', lg: '15px' }}
          px={{ base: '18px', sm: '15px', lg: '20px' }}
          minH={{ base: '35px', md: '90px' }}
        >
          <SingleImage
            my="0"
            sectionContent={card?.image}
            sync={true}
            w={{ base: '70px', md: '90px' }}
            h={{ base: '70px', md: '90px' }}
            objectFit="contain"
          />
        </Box>
        <Box
          w="100%"
          p={0}
          borderLeft={{
            base: lang === 'ar' ? 'none' : '7px solid #A81D28',
            sm: lang === 'ar' ? 'none' : '6px solid #A81D28',
          }}
          borderRight={{
            base: lang === 'ar' ? '7px solid #A81D28' : 'none',
            sm: lang === 'ar' ? '6px solid #A81D28' : 'none',
          }}
          h={{ base: '55%', sm: '63%' }}
          mt={{ base: '17px', md: '0' }}
          pb="20px"
          display={'flex'}
          fontFamily="FedraSansStd-book"
          flexDir="column"
          px="20px"
          dir={lang == 'ar' ? 'rtl' : 'ltr'}
        >
          <Flex w="100%" justifyContent="space-between" alignItems="center">
            <Heading
              as="h3"
              fontFamily="FedraSansStd-medium"
              {...ProgramSupportSt[lang].cardTitle}
              mb="16px"
            >
              {card?.image?.title}
            </Heading>
          </Flex>

          <Flex w="100%" justifyContent="space-between" flexDirection="column">
            <StructuredTextParser
              fontSize="16px"
              lineHeight="20px"
              display={{ base: show ? 'block' : 'none', sm: 'block' }}
              {...ProgramSupportSt[lang].stText}
              mt="0"
              // {...ResearchShowsSt[lang].cardText}
              noOfLines={txtHide && 1}
              str={`${descText.slice(0, readMoreTxt)}${
                descText.length > readLessTxtCount ? '...' : ''
              } `}
            />

            {descText?.length > readLessTxtCount && (
              <>
                {txtHide ? (
                  <Box
                    width="100%"
                    color={color ?? '#F37021'}
                    fontSize="16px"
                    fontFamily="FedraSansStd-medium"
                    pt="10px"
                    onClick={viewText}
                    cursor="pointer"
                    textAlign={lang === 'ar' ? 'right' : 'left'}
                  >
                    {(pageData > 0 &&
                      pageData?.pageConfig[0]?.value?.['post-prg']?.readless) ||
                      'Read More'}
                  </Box>
                ) : (
                  <Box
                    width="100%"
                    color={color ?? '#F37021'}
                    fontSize="16px"
                    fontFamily="FedraSansStd-medium"
                    pt="10px"
                    onClick={lessText}
                    cursor="pointer"
                    textAlign={lang === 'ar' ? 'right' : 'left'}
                  >
                    {pageData?.pageConfig[0]?.value?.['post-prg']?.readless ||
                      'Read Less'}
                  </Box>
                )}
              </>
            )}
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default RemarketProgramSupportCard;
